import type { CSSProperties } from 'react'

interface SkeletonProps {
  width?: number | string
  height?: number | string
  radius?: number | string
  className?: string
  style?: CSSProperties
}

export function Skeleton({ width = '100%', height = 14, radius = 6, className, style }: SkeletonProps) {
  return (
    <div
      className={className}
      style={{
        width,
        height,
        borderRadius: radius,
        background: 'linear-gradient(90deg, var(--bg-deep) 0%, var(--bg-card) 50%, var(--bg-deep) 100%)',
        backgroundSize: '200% 100%',
        animation: 'morph-skeleton 1.4s ease-in-out infinite',
        ...style,
      }}
    />
  )
}

export function SkeletonCard({ height = 84, row = false }: { height?: number; row?: boolean }) {
  return (
    <div
      style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: 10,
        padding: row ? '12px 16px' : '16px 20px',
        display: 'flex',
        flexDirection: row ? 'row' : 'column',
        alignItems: row ? 'center' : undefined,
        gap: row ? 14 : 10,
        minHeight: height,
      }}
    >
      {row && (
        <div
          style={{
            flexShrink: 0,
            width: 40,
            height: 40,
            borderRadius: 10,
            background: 'var(--bg-deep)',
          }}
        />
      )}
      <div style={{ flex: row ? 1 : undefined, display: 'flex', flexDirection: 'column', gap: row ? 8 : 10 }}>
        <Skeleton width="58%" height={row ? 14 : 16} />
        <Skeleton width="38%" height={11} />
        {row && <Skeleton width="25%" height={10} />}
      </div>
    </div>
  )
}

export function SkeletonRow({ cols = 4 }: { cols?: number }) {
  return (
    <tr style={{ borderTop: '1px solid var(--border)' }}>
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} style={{ padding: '12px 14px' }}>
          <Skeleton width={i === 0 ? '70%' : '50%'} height={12} />
        </td>
      ))}
    </tr>
  )
}

export function SkeletonInput({ maxWidth = 320 }: { maxWidth?: number }) {
  return (
    <div
      style={{
        width: '100%',
        maxWidth,
        height: 34,
        borderRadius: 6,
        border: '1px solid var(--border)',
        background: 'var(--bg-input)',
        opacity: 0.6,
      }}
    />
  )
}
